// extracted by mini-css-extract-plugin
export default {"nav":"navbar_nav__dXYOM","img":"navbar_img__TF5R6","searchField":"navbar_searchField__J9zHk","feedback":"navbar_feedback__Ali4L"};